<div class="container">
    <form [formGroup]="formulario">

        <div class="row pt-1">
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Criação De</mat-label>
                    <input matInput id="txtCreateIniDt" #txtCreateIniDt maxlength="10" mask="d0/M0/0000"
                        formControlName="created_at_inicial">
                    <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                    <mat-hint align="end">{{txtCreateIniDt.value.length}} / 10</mat-hint>
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Criação Até</mat-label>
                    <input matInput id="txtCreateFinDt" #txtCreateFinDt maxlength="10" mask="d0/M0/0000"
                        formControlName="created_at_final">
                    <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                    <mat-hint align="end">{{txtCreateFinDt.value.length}} / 10</mat-hint>
                </mat-form-field>
            </div>
        </div>

        <div class="row pt-3">
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Safra</mat-label>
                    <!-- <input matInput name="safra" formControlName="safra"  maxlength="8"
                        #txtSafra id="txtSafra"> -->
                          <!--[matAutocomplete]="auto"-->
                        <mat-select formControlName="safra" multiple>

                          <mat-option *ngFor="let item of filteredOptionsSafra | async" [value]="item.name">
                            {{item.name | uppercase}}
                        </mat-option>

                        </mat-select>
                    <!-- <mat-autocomplete #auto="matAutocomplete">
                        <mat-option *ngFor="let item of filteredOptionsSafra | async" [value]="item.name">
                            {{item.name | uppercase}}
                        </mat-option>
                    </mat-autocomplete> -->
                    <!-- <mat-hint align="end">{{txtSafra.value.length}} / 8</mat-hint> -->
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Site Recebimento</mat-label>
                    <input matInput name="site_recebimento" formControlName="site_recebimento" [matAutocomplete]="auto3"
                        maxlength="15" #txtSiteRecebimento id="txtSiteRecebimento" readonly class="InputBlockColor">
                    <mat-autocomplete #auto3="matAutocomplete">
                        <mat-option *ngFor="let item of filteredOptionsSiteRecebimento | async" [value]="item.initials">
                            {{item.initials | uppercase}}
                        </mat-option>
                    </mat-autocomplete>
                    <i matSuffix class="{{iconDisableField}}"></i>
                    <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                    <mat-hint align="end">{{txtSiteRecebimento.value.length}} / 15</mat-hint>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Cerar</mat-label>
                    <input matInput name="txtCerar" formControlName="cerar" maxlength="17" #txtCerar id="txtCerar">
                    <mat-hint align="end">{{txtCerar.value.length}} / 17</mat-hint>
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Contrato Jurídico</mat-label>
                    <input matInput #txtContrato maxlength="20" formControlName="contrato_juridico">
                    <mat-hint align="end">{{txtContrato.value?.length || 0}}/20</mat-hint>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Data da Colheita De</mat-label>
                    <input matInput id="txtDataInicio" #txtDataInicio maxlength="10" mask="d0/M0/0000"
                        formControlName="data_colheita_inicial">
                    <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                    <mat-hint align="end">{{txtDataInicio.value.length}} / 10</mat-hint>
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Data da Colheita Até</mat-label>
                    <input matInput id="txtDataFim" #txtDataFim maxlength="10" mask="d0/M0/0000"
                        formControlName="data_colheita_final">
                    <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                    <mat-hint align="end">{{txtDataFim.value.length}} / 10</mat-hint>
                </mat-form-field>
            </div>
        </div>

        <div class="row pt-3">
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Híbrido RNC/Linhagem</mat-label>
                        <mat-select formControlName="hibrido_rnc" multiple>
                            <input matInput type="text" class="form-control filterTxt"
                                placeholder="Pesquisar por..."
                                (keyup)="createFilterHibrido($event.target.value)">
                            <mat-option *ngFor="let item of listHibridoRnc" [value]="item.name">
                                {{item.name | uppercase}}
                            </mat-option>
                        </mat-select>
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Responsável Lançamento</mat-label>
                    <!-- <input matInput name="responsavel_lancamento" formControlName="responsavel_lancamento"
                         maxlength="80" #txtRespLancamento id="txtRespLancamento"
                        class="InputUnblockColor"> -->
                        <!--[matAutocomplete]="auto4"-->

                        <mat-select formControlName="responsavel_lancamento" multiple>

                          <mat-option *ngFor="let item of filteredOptionsRespLancamento | async" [value]="item.name">
                            {{item.name | uppercase}}
                        </mat-option>

                        </mat-select>

                    <!-- <mat-autocomplete #auto4="matAutocomplete">
                        <mat-option *ngFor="let item of filteredOptionsRespLancamento | async" [value]="item.name">
                            {{item.name | uppercase}}
                        </mat-option>
                    </mat-autocomplete> -->
                    <!-- <mat-hint align="end">{{txtRespLancamento.value.length}} / 80</mat-hint> -->
                </mat-form-field>
            </div>
        </div>

        <div class="row pt-1">
            <div class="col-lg-6 col-md-6" *ngIf="areaSelect.includes('Básica')">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Número do Campo</mat-label>
                    <input matInput formControlName="numero_campo">
                </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6">
                <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                    <mat-label class="InputLabelColor">Status</mat-label>
                    <mat-select name="status" formControlName="is_incomplete" disableOptionCentering>
                        <mat-option *ngFor="let item of listStatus" [value]="item.value">
                            {{item.value ? 'INCOMPLETO ' : 'COMPLETO'}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-lg col-md text-right">
                <button mat-flat-button color="primary" matTooltip="Limpar" class="textoGeral mr-1 btnSize"
                    (click)="clearFilter()"><i class="fa fa-paint-brush fa-1x btnIcon"></i> Limpar</button>
                <button mat-flat-button color="primary" matTooltip="Pesquisar" class="textoGeral mr-1 btnSize"
                    (click)="sendFilter()"><i class="fa fa-search fa-1x btnIcon"></i> Pesquisar</button>
            </div>
        </div>

    </form>
</div>
